import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const NotificationsLink = () => {

  return (
    <AsideMenuLink
      pathname={P.NOTIFICATIONS_PAGE}
      subject={S.NOTIFICATIONS_PAGE}
      icon={'Notifications_purple.svg'}
      label={<FormattedMessage id="notifications-page-link" defaultMessage="Notifications page"/>}
      isSubSection={false}
    />
  );
};

export default NotificationsLink;
